import { environment } from '../../environments/environment';

export const DATABASE_UPLOADED_STATICS_URLS = {
  logo_img_url: `${environment.XANO_SERVER_URL}/uploads/app_logo/1771838230056-RespondEDU-Logo-Colored.png`,
  teacher_only_logo_image_url: `${environment.XANO_SERVER_URL}/uploads/app_logo/1771838230363-teacher_only_colored_logo.png`,
};
